import React from 'react'

import withTranslate from 'react-redux-multilingual/lib/withTranslate'

import { TextField, Container } from '@material-ui/core'
import Modal from '../../../../../../UI/Modal/Modal'
import Button from '../../../../../../UI/Button/Button'

const PerformanceLevelModal = ({
  modalOpen,
  closeModalHandler,
  translate,
  targetRow,
  setTargetRow,
  inputChanged
}) => {
  return (
    <Modal
      size={'sm'}
      open={modalOpen}
      onHide={closeModalHandler}
      header={targetRow ? `${targetRow?.item?.item_name}` : ' '}
      footer={
        <Button style={{ width: 'inherit' }} color={'primary'} clicked={() => closeModalHandler()}>
          {translate('save')}
        </Button>
      }>
      <Container>
        <TextField
          label={translate('performanceLevel')}
          multiline
          fullWidth
          value={targetRow?.p_level || targetRow?.item?.p_level || ''}
          onChange={e => {
            setTargetRow({ ...targetRow, p_level: e.target.value })
            inputChanged({ ...targetRow, p_level: e.target.value })
          }}
        />
      </Container>
    </Modal>
  )
}

export default withTranslate(PerformanceLevelModal)
